function importAll(r) {
    r.keys().forEach(r);
}

// get all of the app's js and jsx files - excluding modules and spec files
importAll(
    require.context("./", true, /^(?!.*\.module\.js$)^(?!.*\.(spec|test)\.(js|jsx)$).*\.(js|jsx)$/)
);
